export default __webpack_public_path__ + "static/media/hero-background.14274b65.webp";